/*!
 * Amour Cart — native slide cart (Qikify lookalike)
 * Config via window.AmourCartConfig (set from Liquid).
 */
(function () {
  'use strict';

  var cfg = window.AmourCartConfig || {};
  function freeShipCents() {
    var by = cfg.freeShippingByCountry || {};
    var country = String(cfg.country || '').toUpperCase();
    var amount =
      country && by[country] != null
        ? Number(by[country])
        : Number(cfg.freeShippingAmount) || 40;
    return Math.round(amount * 100);
  }
  var i18n = Object.assign(
    {
      title: 'KOŠARICA',
      close: 'Zapri',
      empty: 'Vaša košarica je trenutno prazna.',
      emptyBtn: 'Nadaljujte z nakupovanjem',
      continue: 'Nadaljujte z nakupovanjem',
      checkout: 'Na blagajno',
      subtotal: 'Vmesni znesek',
      remove: 'Odstrani',
      recommended: 'Priporočeni izdelki',
      add: 'Dodaj',
      discountToggle: 'Uporabi kodo',
      discountApply: 'Shrani',
      discountPlaceholder: 'Vnesite kodo za popust',
      discountHint: '* Popust bo izračunan in uporabljen ob zaključku nakupa.',
      discountInvalid: 'Vnesite veljavno kodo za popust',
      termsHtml: "Strinjam se s <a href='/policies/terms-of-service' target='_blank' rel='noopener'>Pogoji poslovanja</a>",
      goalNeed: 'Kupite še za <strong>{amount}</strong>, da boste uživali v <strong>BREZPLAČNI DOSTAVI</strong>',
      goalDone: 'Super! Čaka te <strong>BREZPLAČNA DOSTAVA</strong>!',
      termsRequired: 'Za nadaljevanje sprejmite pogoje poslovanja.',
    },
    cfg.i18n || {}
  );

  var state = {
    cart: null,
    open: false,
    terms: false,
    loading: false,
    recs: [],
    discountOpen: false,
    discountError: '',
  };

  /* handle → { label, fragrance } | null — SI inspired-by enrichment */
  var inspiredCache = Object.create(null);
  /* handle → full cartdata JSON (incl. rating) | null */
  var cartdataCache = Object.create(null);

  function getInspiredFromProps(item) {
    var props = item && item.properties;
    if (!props) return null;
    for (var k in props) {
      if (!Object.prototype.hasOwnProperty.call(props, k)) continue;
      if (!/navdihnjen|inspired/i.test(k)) continue;
      var val = props[k];
      if (val == null || String(val).trim() === '') continue;
      var label = String(k).replace(/:\s*$/, '') + ':';
      return { label: label, fragrance: String(val).trim() };
    }
    return null;
  }

  function rememberInspiredFromCartdata(handle, data) {
    if (!cfg.showInspiredBy) return;
    if (!data || !data.has_inspired) {
      inspiredCache[handle] = null;
      return;
    }
    var dek = String(data.dek || '').trim();
    var frag = String(data.fragrance || '').trim();
    var detail = '';
    if (dek && frag) {
      detail = dek === frag ? dek : dek + ' - ' + frag;
    } else {
      detail = frag || dek;
    }
    if (!detail) {
      inspiredCache[handle] = null;
      return;
    }
    var label = String(data.label || i18n.inspiredLabel || 'Parfum, navdihnjen po:').replace(/:\s*$/, '') + ':';
    inspiredCache[handle] = { label: label, fragrance: detail };
  }

  function fetchCartdata(handle) {
    if (!handle) return Promise.resolve(null);
    if (Object.prototype.hasOwnProperty.call(cartdataCache, handle)) {
      return Promise.resolve(cartdataCache[handle]);
    }
    var url = '/products/' + encodeURIComponent(handle) + '?view=cartdata';
    /* Do NOT send Accept: application/json — Shopify then returns the
       standard product JSON and ignores the cartdata alternate template. */
    return fetch(url, { credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) throw new Error('cartdata ' + res.status);
        return res.text();
      })
      .then(function (txt) {
        var trimmed = (txt || '').trim();
        if (!trimmed || trimmed.charAt(0) !== '{') {
          cartdataCache[handle] = null;
          rememberInspiredFromCartdata(handle, null);
          return null;
        }
        var data = JSON.parse(trimmed);
        cartdataCache[handle] = data;
        rememberInspiredFromCartdata(handle, data);
        return data;
      })
      .catch(function () {
        cartdataCache[handle] = null;
        rememberInspiredFromCartdata(handle, null);
        return null;
      });
  }

  function ratingFromCartdata(data) {
    if (!data) return null;
    var count = Number(data.rating_count) || 0;
    var value = Number(data.rating);
    if (!(count > 0) || !(value > 0)) return null;
    return { value: value, count: count };
  }

  function ensureInspired(item) {
    if (!cfg.showInspiredBy || !item) return Promise.resolve(null);
    var fromProps = getInspiredFromProps(item);
    if (fromProps) {
      if (item.handle) inspiredCache[item.handle] = fromProps;
      return Promise.resolve(fromProps);
    }
    var handle = item.handle;
    if (!handle) return Promise.resolve(null);
    if (Object.prototype.hasOwnProperty.call(inspiredCache, handle)) {
      return Promise.resolve(inspiredCache[handle]);
    }
    return fetchCartdata(handle).then(function () {
      return inspiredCache[handle] || null;
    });
  }

  function resolveInspiredForCart(cart) {
    if (!cfg.showInspiredBy || !cart || !cart.items || !cart.items.length) {
      return Promise.resolve();
    }
    return Promise.all(cart.items.map(ensureInspired));
  }

  function ratingHtml(rating) {
    if (!rating || !(rating.count > 0) || !(rating.value > 0)) return '';
    var value = Math.max(0, Math.min(5, Number(rating.value)));
    var stars = '';
    for (var i = 1; i <= 5; i++) {
      var fill = Math.max(0, Math.min(1, value - (i - 1)));
      stars +=
        '<span class="ac-star" aria-hidden="true">' +
        '<span class="ac-star__base">★</span>' +
        (fill > 0
          ? '<span class="ac-star__fill" style="width:' + Math.round(fill * 100) + '%">★</span>'
          : '') +
        '</span>';
    }
    var score = value.toFixed(value % 1 === 0 ? 0 : 1);
    return (
      '<p class="ac-upsell__rating" aria-label="' +
      score +
      ' / 5, ' +
      rating.count +
      '">' +
      '<span class="ac-upsell__stars">' +
      stars +
      '</span>' +
      '<span class="ac-upsell__score">' +
      score +
      '</span>' +
      '<span class="ac-upsell__count">(' +
      rating.count +
      ')</span></p>'
    );
  }

  /* Inline SVG icons (Lucide-style, 24x24 viewBox, stroke currentColor) */
  var ICONS = {
    close: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>',
    minus: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M5 12h14"/></svg>',
    plus: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M5 12h14"/><path d="M12 5v14"/></svg>',
    trash: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 6h18"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6"/><path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/></svg>',
    chevron: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m6 9 6 6 6-6"/></svg>',
    lock: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" style="width:14px;height:14px"><rect width="18" height="11" x="3" y="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>',
    bag: '<svg class="ac-empty__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z"/><path d="M3 6h18"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>',
  };

  function money(cents) {
    var n = (Number(cents) || 0) / 100;
    try {
      if (window.Shopify && Shopify.formatMoney) {
        return Shopify.formatMoney(cents, cfg.moneyFormat || undefined);
      }
    } catch (e) {}
    try {
      return new Intl.NumberFormat(cfg.locale || 'sl-SI', {
        style: 'currency',
        currency: cfg.currency || 'EUR',
      }).format(n);
    } catch (e2) {
      return n.toFixed(2).replace('.', ',') + ' €';
    }
  }

  function el(html) {
    var t = document.createElement('template');
    t.innerHTML = String(html).trim();
    return t.content.firstElementChild;
  }

  function qs(sel, root) {
    return (root || document).querySelector(sel);
  }

  function setLoading(on) {
    state.loading = !!on;
    document.documentElement.classList.toggle('ac-loading', state.loading);
  }

  async function fetchCart() {
    var res = await fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } });
    if (!res.ok) throw new Error('cart.js ' + res.status);
    state.cart = await res.json();
    updateBubbles();
    return state.cart;
  }

  function updateBubbles() {
    var count = (state.cart && state.cart.item_count) || 0;
    document.querySelectorAll('.cart-link__bubble-num, [data-cart-count]').forEach(function (node) {
      node.textContent = String(count);
    });
    document.querySelectorAll('.cart-link__bubble').forEach(function (node) {
      node.classList.toggle('cart-link__bubble--visible', count > 0);
    });
  }

  async function changeLine(key, quantity) {
    setLoading(true);
    try {
      var res = await fetch('/cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity }),
      });
      if (!res.ok) throw new Error('change ' + res.status);
      state.cart = await res.json();
      updateBubbles();
      await render();
      if (quantity > 0) loadRecs();
    } finally {
      setLoading(false);
    }
  }

  async function addVariant(id, quantity) {
    setLoading(true);
    try {
      var res = await fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(id), quantity: quantity || 1 }] }),
      });
      if (!res.ok) {
        var err = await res.json().catch(function () { return {}; });
        throw new Error(err.description || 'add failed');
      }
      await fetchCart();
      await openCart();
      await render();
      loadRecs();
    } finally {
      setLoading(false);
    }
  }

  async function applyDiscount(code) {
    code = String(code || '').trim();
    state.discountError = '';
    if (!code) {
      state.discountError = i18n.discountInvalid;
      renderFooterOnly();
      return;
    }
    setLoading(true);
    try {
      // Shopify applies discount codes via /discount/{code}
      await fetch('/discount/' + encodeURIComponent(code), {
        credentials: 'same-origin',
        redirect: 'follow',
      });
      await fetchCart();
      await render();
      state.discountOpen = false;
    } catch (e) {
      state.discountError = i18n.discountInvalid;
      renderFooterOnly();
    } finally {
      setLoading(false);
    }
  }

  async function loadRecs() {
    try {
      var cart = state.cart;
      if (!cart || !cart.items || !cart.items.length) {
        state.recs = [];
        renderUpsellOnly();
        return;
      }
      var productId = cart.items[0].product_id;
      var inCart = {};
      cart.items.forEach(function (it) { inCart[it.product_id] = true; });
      var url =
        '/recommendations/products.json?product_id=' +
        encodeURIComponent(productId) +
        '&limit=6&intent=related';
      var res = await fetch(url, { credentials: 'same-origin' });
      if (!res.ok) return;
      var data = await res.json();
      var products = (data.products || []).filter(function (p) {
        return !inCart[p.id] && p.available !== false;
      }).slice(0, 3);
      state.recs = products;
      renderUpsellOnly();
      await Promise.all(
        products.map(function (p) {
          if (!p.handle) return Promise.resolve();
          return fetchCartdata(p.handle).then(function (meta) {
            p._rating = ratingFromCartdata(meta);
          });
        })
      );
      renderUpsellOnly();
    } catch (e) {
      /* ignore */
    }
  }

  function goalHtml(cart) {
    var total = (cart && cart.items_subtotal_price != null)
      ? cart.items_subtotal_price
      : (cart && cart.total_price) || 0;
    var shipGoal = freeShipCents();
    var pct = Math.max(0, Math.min(100, (total / shipGoal) * 100));
    var text =
      total >= shipGoal
        ? i18n.goalDone
        : i18n.goalNeed.replace('{amount}', money(shipGoal - total));
    return (
      '<div class="ac-goal' + (total >= shipGoal ? ' ac-goal--done' : '') + '" data-ac-goal>' +
      '<p class="ac-goal__text">' + text + '</p>' +
      '<div class="ac-goal__bar"><div class="ac-goal__fill" style="width:' + pct + '%"></div></div>' +
      '</div>'
    );
  }

  function itemHtml(item) {
    var img = (item.image || '').replace(/(\.[^.]+)(\?|$)/, '_200x$1$2') || '';
    var variant = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
    var compare =
      item.original_line_price > item.final_line_price
        ? '<span class="ac-item__compare">' + money(item.original_line_price) + '</span>'
        : item.original_price > item.final_price
          ? '<span class="ac-item__compare">' + money(item.original_price * item.quantity) + '</span>'
          : '';
    var inspired =
      cfg.showInspiredBy
        ? getInspiredFromProps(item) || (item.handle && inspiredCache[item.handle]) || null
        : null;
    var inspiredHtml =
      inspired && inspired.fragrance
        ? '<p class="ac-item__inspired">' +
          '<span class="ac-item__inspired-label">' +
          escapeHtml(inspired.label || 'Parfum, navdihnjen po:') +
          '</span> ' +
          '<span class="ac-item__inspired-detail">' +
          escapeHtml(inspired.fragrance) +
          '</span></p>'
        : '';
    return (
      '<article class="ac-item" data-key="' + item.key + '">' +
      '<img class="ac-item__img" src="' + img + '" alt="" loading="lazy" width="78" height="78">' +
      '<div>' +
      '<a class="ac-item__title" href="' + item.url + '">' + escapeHtml(item.product_title) + '</a>' +
      inspiredHtml +
      (variant ? '<p class="ac-item__variant">' + escapeHtml(variant) + '</p>' : '') +
      '<div class="ac-item__row">' +
      '<div class="ac-qty">' +
      '<button type="button" data-ac-qty="-1" aria-label="&minus;1">' + ICONS.minus + '</button>' +
      '<span>' + item.quantity + '</span>' +
      '<button type="button" data-ac-qty="1" aria-label="+1">' + ICONS.plus + '</button>' +
      '</div>' +
      '<div class="ac-item__prices">' +
      compare +
      '<span class="ac-item__price">' + money(item.final_line_price) + '</span>' +
      '</div>' +
      '</div>' +
      '<button type="button" class="ac-item__remove" data-ac-remove>' + ICONS.trash + i18n.remove + '</button>' +
      '</div></article>'
    );
  }

  function upsellHtml() {
    if (!state.recs.length) return '<div data-ac-upsell></div>';
    var cards = state.recs
      .map(function (p) {
        var v = (p.variants || []).find(function (x) { return x.available; }) || (p.variants || [])[0];
        if (!v) return '';
        var img = p.featured_image || (p.images && p.images[0]) || '';
        if (img && typeof img === 'object') img = img.src || '';
        return (
          '<div class="ac-upsell__card">' +
          '<img src="' + img + '" alt="" width="64" height="64" loading="lazy">' +
          '<div><p class="ac-upsell__name">' + escapeHtml(p.title) + '</p>' +
          ratingHtml(p._rating) +
          '<p class="ac-upsell__price">' + money(v.price) + '</p></div>' +
          '<button type="button" class="ac-upsell__add" data-ac-add="' + v.id + '">' + i18n.add + '</button>' +
          '</div>'
        );
      })
      .join('');
    return (
      '<section class="ac-upsell" data-ac-upsell>' +
      '<h3 class="ac-upsell__title">' + i18n.recommended + '</h3>' +
      '<div class="ac-upsell__track">' + cards + '</div></section>'
    );
  }

  function footerHtml(cart) {
    var count = (cart && cart.item_count) || 0;
    if (!count) {
      return (
        '<div class="ac-footer" data-ac-footer>' +
        '<a class="ac-checkout" href="' + (cfg.collectionsAll || '/collections/all') + '">' + i18n.emptyBtn + '</a>' +
        '</div>'
      );
    }
    var subtotal = cart.items_subtotal_price != null ? cart.items_subtotal_price : cart.total_price;
    return (
      '<div class="ac-footer" data-ac-footer>' +
      '<div class="ac-discount' + (state.discountOpen ? ' is-open' : '') + '">' +
      '<button type="button" class="ac-discount__toggle" data-ac-discount-toggle aria-expanded="' + (state.discountOpen ? 'true' : 'false') + '">' +
      i18n.discountToggle + ' ' + ICONS.chevron + '</button>' +
      '<div class="ac-discount__form">' +
      '<input type="text" data-ac-discount-input placeholder="' + escapeAttr(i18n.discountPlaceholder) + '" autocomplete="off">' +
      '<button type="button" data-ac-discount-apply>' + i18n.discountApply + '</button></div>' +
      '<p class="ac-discount__hint">' + i18n.discountHint + '</p>' +
      (state.discountError ? '<p class="ac-discount__error">' + escapeHtml(state.discountError) + '</p>' : '') +
      '</div>' +
      '<div class="ac-subtotal"><span>' + i18n.subtotal + '</span><span>' + money(subtotal) + '</span></div>' +
      '<label class="ac-terms"><input type="checkbox" data-ac-terms' + (state.terms ? ' checked' : '') + '> <span>' + i18n.termsHtml + '</span></label>' +
      '<button type="button" class="ac-checkout' + (state.terms ? '' : ' is-disabled') + '" data-ac-checkout ' + (state.terms ? '' : 'disabled') + '>' +
      ICONS.lock + i18n.checkout +
      '</button>' +
      '<button type="button" class="ac-continue" data-ac-continue>' + i18n.continue + '</button>' +
      '</div>'
    );
  }

  function escapeHtml(s) {
    return String(s || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }
  function escapeAttr(s) {
    return escapeHtml(s).replace(/'/g, '&#39;');
  }

  function ensureDom() {
    if (qs('#AmourCart')) return;
    document.documentElement.classList.add('amour-cart-on');
    var overlay = el('<div id="AmourCartOverlay" hidden></div>');
    overlay.hidden = false;
    var drawer = el(
      '<aside id="AmourCart" role="dialog" aria-modal="true" aria-label="' + escapeAttr(i18n.title) + '">' +
        '<div class="ac-header">' +
        '<h2 class="ac-header__title" data-ac-title>' + i18n.title + '</h2>' +
        '<button type="button" class="ac-header__close" data-ac-close aria-label="' + escapeAttr(i18n.close) + '">' + ICONS.close + '</button>' +
        '</div>' +
        '<div data-ac-goal-slot></div>' +
        '<div class="ac-body" data-ac-body></div>' +
        '<div data-ac-footer-slot></div>' +
        '</aside>'
    );
    document.body.appendChild(overlay);
    document.body.appendChild(drawer);

    overlay.addEventListener('click', closeCart);
    drawer.addEventListener('click', onDrawerClick);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && state.open) closeCart();
    });
  }

  function onDrawerClick(e) {
    var t = e.target;
    if (!(t instanceof Element)) return;
    if (t.closest('[data-ac-close]') || t.closest('[data-ac-continue]')) {
      closeCart();
      return;
    }
    var qtyBtn = t.closest('[data-ac-qty]');
    if (qtyBtn) {
      var article = qtyBtn.closest('.ac-item');
      if (!article) return;
      var key = article.getAttribute('data-key');
      var item = (state.cart.items || []).find(function (it) { return it.key === key; });
      if (!item) return;
      var delta = Number(qtyBtn.getAttribute('data-ac-qty'));
      changeLine(key, Math.max(0, item.quantity + delta));
      return;
    }
    if (t.closest('[data-ac-remove]')) {
      var art = t.closest('.ac-item');
      if (art) changeLine(art.getAttribute('data-key'), 0);
      return;
    }
    var add = t.closest('[data-ac-add]');
    if (add) {
      addVariant(add.getAttribute('data-ac-add'), 1);
      return;
    }
    if (t.closest('[data-ac-discount-toggle]')) {
      state.discountOpen = !state.discountOpen;
      renderFooterOnly();
      return;
    }
    if (t.closest('[data-ac-discount-apply]')) {
      var input = qs('[data-ac-discount-input]', qs('#AmourCart'));
      applyDiscount(input && input.value);
      return;
    }
    if (t.matches('[data-ac-terms]') || t.closest('[data-ac-terms]')) {
      var box = qs('[data-ac-terms]', qs('#AmourCart'));
      state.terms = !!(box && box.checked);
      renderFooterOnly();
      return;
    }
    if (t.closest('[data-ac-checkout]')) {
      if (!state.terms) {
        alert(i18n.termsRequired);
        return;
      }
      window.location.href = '/checkout';
    }
  }

  function renderFooterOnly() {
    var slot = qs('[data-ac-footer-slot]');
    if (!slot) return;
    slot.innerHTML = footerHtml(state.cart || { item_count: 0, items: [] });
  }

  function renderUpsellOnly() {
    var body = qs('[data-ac-body]');
    if (!body) return;
    var mount = qs('[data-ac-upsell]', body);
    var html = upsellHtml();
    if (mount) mount.outerHTML = html;
    else if ((state.cart && state.cart.item_count) > 0) body.insertAdjacentHTML('beforeend', html);
  }

  async function render() {
    ensureDom();
    var cart = state.cart || { item_count: 0, items: [] };
    if (cart.item_count) await resolveInspiredForCart(cart);

    var title = qs('[data-ac-title]');
    if (title) {
      title.innerHTML =
        escapeHtml(i18n.title) +
        (cart.item_count ? ' <span class="ac-header__count">(' + cart.item_count + ')</span>' : '');
    }

    var goalSlot = qs('[data-ac-goal-slot]');
    if (goalSlot) {
      goalSlot.innerHTML = cart.item_count ? goalHtml(cart) : '';
    }

    var body = qs('[data-ac-body]');
    if (body) {
      if (!cart.item_count) {
        body.innerHTML =
          '<div class="ac-empty">' +
          ICONS.bag +
          '<p class="ac-empty__text">' +
          i18n.empty +
          '</p><a class="ac-empty__btn" href="' +
          (cfg.collectionsAll || '/collections/all') +
          '">' +
          i18n.emptyBtn +
          '</a></div>';
      } else {
        body.innerHTML = (cart.items || []).map(itemHtml).join('') + upsellHtml();
      }
    }
    renderFooterOnly();
  }

  async function openCart() {
    ensureDom();
    if (!state.cart) await fetchCart();
    await render();
    loadRecs();
    state.open = true;
    qs('#AmourCart').classList.add('is-open');
    qs('#AmourCartOverlay').classList.add('is-open');
    document.documentElement.classList.add('amour-cart-open');
  }

  function closeCart() {
    state.open = false;
    var d = qs('#AmourCart');
    var o = qs('#AmourCartOverlay');
    if (d) d.classList.remove('is-open');
    if (o) o.classList.remove('is-open');
    document.documentElement.classList.remove('amour-cart-open');
  }

  function bindTriggers() {
    document.addEventListener(
      'click',
      function (e) {
        var a = e.target && e.target.closest && e.target.closest('a[href="/cart"], a[href$="/cart"], #HeaderCartTrigger, [data-amour-cart-open]');
        if (!a) return;
        // Let modifier clicks through
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
        e.preventDefault();
        e.stopPropagation();
        openCart();
      },
      true
    );
  }

  function patchCartAdd() {
    var origFetch = window.fetch;
    if (!origFetch) return;
    window.fetch = function () {
      var args = arguments;
      var input = args[0];
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      return origFetch.apply(this, args).then(function (res) {
        try {
          if (/\/cart\/add(?:\.js)?/i.test(url) && res.ok) {
            setTimeout(function () {
              fetchCart().then(function () {
                if (cfg.autoOpen !== false) openCart().then(render).then(loadRecs);
                else render();
              });
            }, 30);
          }
        } catch (e) {}
        return res;
      });
    };

    // jQuery ajax fallback (Impulse theme)
    if (window.jQuery) {
      jQuery(document).ajaxComplete(function (_e, _xhr, settings) {
        try {
          if (settings && /\/cart\/add/i.test(settings.url || '')) {
            fetchCart().then(function () {
              if (cfg.autoOpen !== false) openCart().then(render).then(loadRecs);
            });
          }
        } catch (err) {}
      });
    }
  }

  function killQikifyOpen() {
    // Best-effort: stop Qikify from stealing cart icon / auto-open
    try {
      document.documentElement.classList.add('amour-cart-on');
    } catch (e) {}
  }

  async function init() {
    killQikifyOpen();
    ensureDom();
    bindTriggers();
    patchCartAdd();
    try {
      await fetchCart();
      await render();
    } catch (e) {
      console.warn('[AmourCart] init', e);
    }
    window.AmourCart = { open: openCart, close: closeCart, refresh: fetchCart };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
